module.exports = __webpack_public_path__ + "media/images/donation/logo-paypay-bbc5d810c0ceffbeaa1fc68e5f3d7386.jpg";